<template>
  <div class="examSign borderBox">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <div class="examSign-content">
        <div>
          <van-list :finished="finished" :finished-text="finishedText" @load="getPage()">
            <div v-for="(item, i) in page.list" :key="i">
              <div @click="toExamSign(item)" class="list-item">
                <!-- <img class="item-img" :src="item.specialtyImageUrl"/> -->
                <div class="item-left">
                  <div class="icm-title">
                    <img class="prefix-icon" src="../../static/images/examResult/icon_cj.png" alt="" srcset="">
                    <span class="suffix-label">{{item.specialtyName}}({{ item.gradeName }})成绩</span>
                  </div>
                  <div class="icm-place">所属报名点：{{item.agentName}}</div>
                </div>
                <div class="item-right">
                  <van-icon class="arrow-icon" name="arrow"/>
                </div>
              </div>
            </div>
          </van-list>
        </div>
        <van-empty class="empty" v-if="!page.list && finished" :image="require('../../static/images/examResult/img-wsj.png')" description="暂时没有成绩..."/>
        <!--        <div style="margin: 50px 0;">-->
        <!--          <p style="text-align: center;color: #7d7e82">没有更多内容了</p>-->
        <!--        </div>-->
      </div>
    </van-pull-refresh>
  </div>
</template>
<script>
import { Picker, Popup, Icon, PullRefresh, List, Empty, ImagePreview } from 'vant'

export default {
  components: {
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Icon.name]: Icon,
    [Empty.name]: Empty,
  },
  data () {
    return {
      areaList: [],
      showPicker: false,
      batchId: undefined,
      finishedText: '正在加载中...',
      loading: false,
      finished: false,
      refreshing: false,
      totalPage: 1,
      queryParam: { pageNum: 1, pageSize: 10 },
      page: { pageSize: 10, pageNum: 1, list: [] },
      evaluateExamId: null
    }
  },
  async created () {
    await this.getPage()
  },
  methods: {
    toImagePreview () {
      ImagePreview(['https://zego-davinci-public.oss-cn-shanghai.aliyuncs.com/test/dpm/exam_instructions.png'])
    },
    async onRefresh () {
      try {
        this.finished = false
        this.loading = true
        await this.getPage({ pageNum: 1 })
      } catch (e) {
        this.loading = false
        this.finished = true
        this.Tool.doError(e)
      }
    },
    async getPage (queryParam) {
      this.finishedText = '正在加载中...'
      this.Tool.debounce('examSign-page', async () => {
        try {
          if (this.refreshing) {
            this.page.list = []
            this.refreshing = false
          }
          this.finished = true
          this.queryParam = Object.assign({}, this.queryParam, queryParam)
          let res = await this.$HTTP.ApiExamResult.getresultPage(this.queryParam)
          this.page = res.data
          console.log('this.page :',this.page )
          this.loading = false
          this.finishedText = !this.page.list ? '' : '没有更多内容...'
        } catch (e) {
          this.loading = false
          this.finished = true
          this.Tool.doError(e)
        }
      })
    },
    // async getNewsList () {
    //   const { data } = await this.$HTTP.ApiArticle.articlePageForH5POST({ model: 3, pageNum: 1, pageSize: 2 })
    //   this.newsList = data.list
    // },
    async toExamSign (item) {
      this.$router.push({
        path: "/exam-sign/exam-result",
        query: {
          evaluateExamId: item.evaluateExamId
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .examSign {
    width: 100vw;
    height: 100%;
    background-color: #F6F6F6;
  }
  
  .empty {
    margin-top: 200px/2;
  }

  .examSign-content {
    width: 100%;
    height: 100%;
    padding: 20px 20px 60px 20px;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;

    &-news {
      width: 100%;
      // padding: 16px;
      box-shadow: 0px 0px 8px rgba(9, 5, 78, 0.1);
      border-radius: 8px;
      margin-bottom: 20px;
      border: 1px solid #5e6bfe;
      overflow: hidden;

      .news-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #5e6bfe;
        padding: 16px;

        .news-blod {
          display: flex;
          align-items: center;
          color: #fff;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: bold;
          vertical-align: middle;
        }

        .news-more {
          display: flex;
          align-items: center;
          color: #fff;
          font-size: 12px;
          font-family: PingFang SC;
        }

        .icon-new {
          width: 20px;
          height: 20px;
          margin-right: 8px;
        }

        .icon-more {
          width: 12px;
          height: 12px;
          margin-left: 5px;
        }
      }

      .news-item {
        // display: flex;
        // align-items: center;
        padding: 16px 16px;
        color: #001236;
        font-size: 13px;
        font-family: PingFang SC;

        .news-new {
          padding: 0 3px;
          background: rgba(255, 255, 255, 1);
          border: 1px solid rgba(255, 98, 98, 1);
          border-radius: 1px;
          color: #ff6262;
          font-size: 10px;
          margin-right: 3px;
        }
      }

      .bd1 {
        border-bottom: 1px solid rgba(217, 217, 217, 1);
      }

      .no-contaner {
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 13px;
        font-family: PingFang SC;
        color: #c9ccd6;
      }

      .no-icon {
        width: 18px;
        height: 18px;
      }
    }
  }

  .list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px 0 48px/2 0;
    padding: 35px/2 32px/2;
    background: #FFFFFF;
    border-radius: 10px/2;

    .item-left {
      overflow: hidden;

      .icm-title {
        height: 57px/2;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 40px/2;
        font-family: 'SourceHanSerifCN-Bold';
        font-weight: bold;
        line-height: 57px/2;
        color: #260E09;
        .prefix-icon {
          width: 48px/2;
          height: 48px/2;
          vertical-align: middle;
        }
        .suffix-label {
          margin-left: 5px;
          vertical-align: middle;
        }
      }

      .icm-place {
        height: 33px/2;
        margin-top: 16px/2;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 24px/2;
        font-family: 'SourceHanSerifCN-Regular';
        font-weight: 400;
        line-height: 33px/2;
        color: #908581;
      }
    }

    .item-right {
      margin-left: 10px/2;

      .arrow-icon {
        width: 15px/2;
        height: 27px/2;
        color: #D6CDC9;
      }
    }
  }

  .item-icon {
    line-height: 193px/2;
    margin-right: 35px/2;

    .icon-more {
      width: 15px/2;
      height: 27px/2;
      margin-left: 5px;
      color: #A2A6B8;
    }
  }

  .item-title-tip {
    font-weight: 500;
    height: 45px/2;
    line-height: 25px;
    margin-top: 54px/2;
    margin-bottom: 12px/2;

    p {
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .item-title-tips {
    color: #7D7E82;
  }

  .item-title-msg {
    color: #fff;
  }

  .item-title-btn {
    margin-top: 27px/2;
    width: 150px/2;
    height: 40px/2;
    line-height: 40px/2;
    text-align: center;
    background: rgba(255, 255, 255, 1);
    border-radius: 100px/2;
    font-size: 11px;
  }

  .item-img {
    width: 129px/2;
    height: 129px/2;
    object-fit: contain;
    margin: 32px/2 31px/2;
  }

  .linear-red {
    background: linear-gradient(136deg,
    rgba(255, 144, 161, 1) 0%,
    rgba(255, 112, 134, 1) 100%);
  }

  .linear-blue {
    background: linear-gradient(134deg,
    rgba(56, 186, 255, 1) 0%,
    rgba(56, 124, 255, 1) 100%);
  }

  .linear-yellow {
    background: linear-gradient(134deg,
    rgba(252, 185, 67, 1) 0%,
    rgba(253, 153, 31, 1) 100%);
  }

  .linear-green {
    background: linear-gradient(315deg, #899cfe 0%, #4e61fd 100%);
  }
</style>
<style>
  .van-image-preview .van-image-preview__image {
    overflow: auto !important;
  }

  .van-image-preview .van-image__img {
    height: auto !important;
  }
</style>
